import { DASHBOARD_MODAL_DATE } from "../actionTypes";

export const DashboardModalDate = (date: any) => {
  return {
    type: DASHBOARD_MODAL_DATE,
    payload: date,
  };
};
